/**
 * Tiny SSR-safe i18n helpers for library-level components (shadcn UI, etc.)
 * that must not import LanguageContext to avoid coupling with the app tree.
 *
 * Reads the active language from <html lang="…">, which the LanguageContext
 * keeps in sync on every language change. Falls back to English if
 * unavailable.
 */
export const uiLang = () => {
  if (typeof document === "undefined") return "en";
  const l = document.documentElement.lang;
  if (l === "fr" || l === "es" || l === "en") return l;
  return "en";
};

export const uiText = (dict) => {
  const l = uiLang();
  return dict[l] || dict.en || Object.values(dict)[0] || "";
};

// Pre-baked strings used by shadcn UI wrappers (sr-only accessibility labels).
export const UI_STRINGS = {
  close:      { en: "Close",         fr: "Fermer",       es: "Cerrar" },
  previous:   { en: "Previous",      fr: "Précédent",    es: "Anterior" },
  next:       { en: "Next",          fr: "Suivant",      es: "Siguiente" },
  more:       { en: "More",          fr: "Plus",         es: "Más" },
  previousSlide: { en: "Previous slide", fr: "Diapositive précédente", es: "Diapositiva anterior" },
  nextSlide:  { en: "Next slide",    fr: "Diapositive suivante",  es: "Diapositiva siguiente" },
};
